import { render, staticRenderFns } from "./APIStacks.vue?vue&type=template&id=d8629c38&scoped=true"
import script from "./APIStacks.vue?vue&type=script&lang=js"
export * from "./APIStacks.vue?vue&type=script&lang=js"
import style0 from "./APIStacks.vue?vue&type=style&index=0&id=d8629c38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8629c38",
  null
  
)

export default component.exports